import Vue from 'vue'
const PageBus = new Vue()
export default PageBus
